import { styled } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({

    closeIcon: {
        fontSize: '20px', 
        color: `${theme.palette.tertiary.closeIconColor} !important`,
        marginRight: "11px"
    },
    roundedBorderDrawer:{
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",
        "& > div > div:nth-child(2) > div":{
            margin: "0px !important"
        }
    },
    container: {
        backgroundColor: `${theme.palette.tertiary.drawerBackgroundColor} !important`,
        maxHeight: '80vh',
        overflowY: 'auto',
    }
}))

export const MessageLayout = styled('div')({
    margin : '0 0 5px 0',
});

export const CloseIconFrame = styled('div')(({ theme, noBorder, noMargin}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: noBorder ? 'none' :'solid 1px',
    borderColor: noBorder ? 'none' : `${theme.palette.tertiary.drawerHeadingBorder} !important`,
    borderStyle: noBorder ? 'none' : 'none none groove none',
}));
export const InformationFrame = styled('div')({
    display: 'flex',
    justifyContent: 'center',
});
export const PopUpTitle = styled('div')(({ theme }) => ({
    padding: '16px',
    fontSize: '16px',
    fontFamily: 'Visuelt',
    fontWeight: '500',
    lineHeight: '18px',
    color:`${theme.palette.tertiary.titleBox} !important`,
}));
export const InfoMsg = styled('div')(({ theme, noMargin, noPadding }) => ({
    padding: '16px',
    fontSize: '12px',
    fontFamily: 'Visuelt',
    fontWeight: '400',
    lineHeight: '18px',
    color:`${theme.palette.primary.cardText} !important`,
    '&>span': {
        fontWeight: '500',
    }    
}));
